import { VCard } from 'vuetify/lib/components/VCard';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showToast),expression:"showToast"}],class:_vm.toastStyle},[_c(VCard,{staticClass:"grey--text text--darken-2",class:_vm.toastContentStyle,on:{"click":_vm.viewSetting}},[_c('div',{class:_vm.msgStyle},[_vm._v(_vm._s(_vm.toastMessage))])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }